import euroCommunityCoins from './euro_community_coins.json';

export interface Coin {
  id: string;
  country: string;
  year: number;
  type: 'standard' | 'commemorative';
  denomination?: string;
  mintmark?: string | null;
  variety?: string;
  strikeType: string;
  name: string;
  subject?: string;
  description?: string;
  mintage: number;
  mintageFormatted: string;
  status?: string;
  imagePath: string;
  imageAltPaths: string[];
  dateIssued?: string | null;
  isJointIssue?: boolean;
}

export const COINS_DATA: Coin[] = euroCommunityCoins as unknown as Coin[];

export function getCoinById(id: string): Coin | undefined {
  return COINS_DATA.find(c => c.id === id);
}

export function getCoinsByCountry(country: string): Coin[] {
  return COINS_DATA.filter(c => c.country.toLowerCase() === country.toLowerCase());
}

export function getCoinsByYear(year: number): Coin[] {
  return COINS_DATA.filter(c => c.year === year);
}
